var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgKreislauf = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.3 122.09",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6e9530;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.48,68.45C-1.76,50.86,3.88,32.46,17.4,18.95,37.71-1.36,69.07-3.89,92.13,11.38L103.51,0l9.44,35.22.9,3.34-10.94-2.93-27.63-7.4,10.27-10.27c-19.37-11.82-45-9.33-61.74,7.41-12.4,12.4-16.97,29.67-13.72,45.66l-9.61-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.33,122.09l-10.02-37.4-.31-1.16,11.42,3.06,27.14,7.27-10.15,10.15c19.41,12.04,45.23,9.64,62.08-7.21,12.4-12.4,16.98-29.67,13.72-45.67l9.62,2.57c2.23,17.6-3.41,36.01-16.92,49.52-20.41,20.41-51.99,22.87-75.07,7.36l-11.5,11.5Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKreislauf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/kreislauf.b823fba9185d7a514d36fef19f131481.svg";